import React from "react";

function BarirPrivacy() {
  return (
    <div className="bg-[#eaf2f8] text-[#0d3b66] font-sans p-8 max-w-3xl mx-auto">
      <header className="text-center mb-8">
        <h1 className="text-3xl font-bold text-[#0d3b66]">
          Privacy and Policy
        </h1>
      </header>
      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#ff6f61] mb-4">
          1. Introduction
        </h2>
        <p className="text-lg leading-relaxed">
          Welcome to Barir. This Privacy Policy explains how we collect, use,
          disclose, and safeguard your information when you use our mobile
          application. Please read this policy carefully to understand our views
          and practices regarding your personal data and how we will treat it.
        </p>
      </section>
      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#ff6f61] mb-4">
          2. Information We Collect
        </h2>
        <p className="text-lg leading-relaxed">
          Barir is a fully offline game and does not collect any personal data
          from its users. We do not require you to provide any personal
          information to play the game. The game does not access or store any
          personal data, including but not limited to names, email addresses,
          phone numbers, or location data.
        </p>
      </section>
      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#ff6f61] mb-4">
          3. Use of Information
        </h2>
        <p className="text-lg leading-relaxed">
          Since Barir does not collect any personal data, we do not use or
          process any personal information. The game is designed to be played
          offline and does not connect to any servers or third-party services.
        </p>
      </section>
      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#ff6f61] mb-4">
          4. Security
        </h2>
        <p className="text-lg leading-relaxed">
          We value your trust in using our application, and we are committed to
          ensuring the security of your information. Since the game does not
          collect any data, there are no security concerns related to the
          handling of personal information.
        </p>
      </section>
      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#ff6f61] mb-4">
          5. Changes to This Privacy Policy
        </h2>
        <p className="text-lg leading-relaxed">
          We may update our Privacy Policy from time to time. Thus, we advise
          you to review this page periodically for any changes. We will notify
          you of any changes by posting the new Privacy Policy on this page.
          These changes are effective immediately after they are posted.
        </p>
      </section>
      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#ff6f61] mb-4">
          6. Contact Us
        </h2>
        <p className="text-lg leading-relaxed">
          If you have any questions or suggestions about our Privacy Policy, do
          not hesitate to contact us at tarbaa.kw@gmail.com.
        </p>
      </section>
    </div>
  );
}

export default BarirPrivacy;
